import {
  Box,
  Flex,
  Heading,
  Skeleton,
  SkeletonText,
  Text,
} from "@chakra-ui/react";
import { useActionsDoctors } from "../../Hooks/useActions";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../Hooks/Hooks";
import { DoctorCard } from "./DoctorCard";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { LanguageKeyTypes } from "../../i18n/types";

export function DoctorsList() {
  const [innerHeight, setInnerHeight] = useState<number>();
  const { ActionGetDoctors } = useActionsDoctors();
  const { t } = useTranslation();
  const currentLang = i18next.language as LanguageKeyTypes;

  const { doctors, loading, categories } = useAppSelector(
    (state) => state.doctorsReducer
  );
  useEffect(() => {
    setInnerHeight(document.documentElement.clientHeight);
    ActionGetDoctors();
  }, []);
  return (
    <Box bg="white" fontFamily="inter" pb="10">
      <Flex justifyContent="space-between" alignItems="center" mt="2.5" px="4">
        <Text
          onClick={() => window.history.back()}
          color="blue.400"
          cursor="pointer"
          _active={{ opacity: ".7" }}
        >
          {t("doctors.cancelButton")}
        </Text>
        <Flex>
          <Heading
            as="h3"
            px="4"
            color="#111111"
            fontWeight="500"
            fontSize="18px"
          >
            {t("doctors.pageTitle")}
          </Heading>
          <Text ml="-3.5">®</Text>
        </Flex>
        <Text opacity="0">Cancel</Text>
      </Flex>
      <Heading as="h1" px="4" fontWeight="600" my="5" color="#111111">
        {t("doctors.title")}
      </Heading>

      <Box>
        {loading
          ? [1, 2, 3, 4].map((index) => (
              <Box py="3" mb="2" key={index} px="4">
                <Skeleton
                  startColor="rgb(228, 228, 228)"
                  endColor="rgb(244, 244, 244)"
                  w="180px"
                  mb="4"
                  height="10px"
                />
                <SkeletonText
                  maxW="85%"
                  mb="3"
                  startColor="rgb(228, 228, 228)"
                  endColor="rgb(244, 244, 244)"
                />
              </Box>
            ))
          : categories?.map((el) => {
              const doctorsList = doctors.filter(
                (item) => item.specialist_category.id === el.id
              );
              return !doctorsList?.length ? null : (
                <Box borderBottom="0.5px solid rgb(209, 204, 204)">
                  <Text
                    px="4"
                    mt="14px"
                    mb="2"
                    fontSize="20px"
                    fontWeight="500"
                  >
                    {el[`name_${currentLang}`]}:
                  </Text>
                  {doctorsList.map((doctor) => (
                    <DoctorCard
                      el={doctor}
                      key={doctor.id}
                      bodyHeight={innerHeight}
                    />
                  ))}
                </Box>
              );
            })}
      </Box>
    </Box>
  );
}
